// extracted by mini-css-extract-plugin
module.exports = {"actions":"styles_actions__24QTV","col":"styles_col__2JMXW"};